import { render, staticRenderFns } from "./AgentSegmentPopup.vue?vue&type=template&id=0a18a87c"
import script from "./AgentSegmentPopup.vue?vue&type=script&lang=js"
export * from "./AgentSegmentPopup.vue?vue&type=script&lang=js"
import style0 from "./AgentSegmentPopup.vue?vue&type=style&index=0&id=0a18a87c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports